import React, { Component }  from 'react'
import { connect } from 'react-redux'
import CommonTable from 'components/Table'
import * as R from 'ramda'
import Moment from 'moment'

import { Column } from 'react-virtualized'
import Badge from 'components/Badge'
import LeaseStatusIcon from './StatusIcon'
import Numeral from 'numeral'
import calcTable from 'utils/calcTable'
import { leasesTable }  from 'selectors/leases'
import { getMonth } from 'utils/date'

let select = (state, props) => ({
	leases: leasesTable(state)
})

export class LeaseTable extends Component{
	render(){
		let { props } = this
		let cols = {
			property:{min:200, avg:250}
		  , tenant: {min:200, avg:250}
		  , balance: {min: 90, avg: 200}
		  , dateFrom: 180
		  , dateTill:180
		  , rent: 120
		  , attachComment:70
		}
		cols = calcTable(props.width || (window.innerWidth-60), cols)
		return(
			<CommonTable entity="lease" showAll={props.showAll} data={props.leases}>
					{cols.property &&
						<Column
							width={cols.property}
							label="property"
							dataKey="property"
						/>
					}
					{cols.tenant &&
						<Column
							width={cols.tenant}
							label="tenant"
							dataKey="tenant"
						/>
					}
					{
						cols.balance &&
						<Column
							width={cols.balance}
							label="balance"
							dataKey="balance"
							headerRenderer={()=><div style={{textAlign:"right", width:"100%", height:"19px", paddingRight:"20px"}}>balance</div>}
	   					 	style={{textAlign:"right", paddingRight:"20px"}}
							cellRenderer={({ cellData }) => (
								<div>
									{((Math.round(cellData) < 0)?'-':'')+"$" + Numeral(Math.abs(cellData)).format('0,0')}
								</div>
							)}
						/>
					}
					{cols.dateFrom &&
						<Column
							width={cols.dateFrom}
							label="dateFrom"
							dataKey="dateFrom"
							cellRenderer={
								({ rowData }) => (rowData.dateFrom?rowData.dateFrom.getDate()+" "+getMonth(rowData.dateFrom.getMonth())+" "+rowData.dateFrom.getFullYear():"")
							}
						/>
					}
					{cols.dateTill &&
						<Column
							width={cols.dateTill}
							label="dateTill"
							dataKey="dateTill"
							cellRenderer={
								({ rowData }) => (rowData.dateTill?rowData.dateTill.getDate()+" "+getMonth(rowData.dateTill.getMonth())+" "+rowData.dateTill.getFullYear():"")
							}
						/>
					}
					{cols.rent &&
						<Column
							width={cols.rent}
							label="rent"
							dataKey="rent"
							cellRenderer={
								({ rowData }) => (rowData.rent?"$"+rowData.rent:"")
							}
						/>
					}
					{cols.attachComment &&
						<Column
							width={cols.attachComment/2}
							label={<i style={{fontSize:"22px"}} className="material-icons">attach_file</i>}
							dataKey='attachments'
							disableSort
							cellRenderer={({ rowData }) =>
								<Badge
									style={{position:"relative", top:"8px", left:"-8px"}}
									badgeContent={rowData.attachments ? rowData.attachments.length : "0"}
									primary={false}
									secondary={rowData.attachments ? !!rowData.attachments.length : false}
								/>
							}
						/>
					}
					{cols.attachComment &&
						<Column
							width={cols.attachComment/2}
							label={<i style={{fontSize:"22px"}} className="material-icons">comment</i>}
							dataKey='comments'
							disableSort
							cellRenderer={({ rowData }) =>
								<Badge
									style={{position:"relative", top:"8px", left:"-8px"}}
									badgeContent={rowData.comments ? rowData.comments.length : "0"}
									primary={false}
									secondary={rowData.comments ? !!rowData.comments.length : false}
								/>
							}
						/>
					}
			</CommonTable>
		)
	}
}
export default connect(select)(LeaseTable)



// WEBPACK FOOTER //
// ./src/routes/manager/leases/Table.js